import { nanoid } from "nanoid/non-secure";
import { Analytics } from "@swiggy-private/swiggylytics";
import { EventField, EventNullProps, RouteToAnalyticsScreenMap, SendEvent } from "./types";

const APP_NAME = "influencer-app";
const ANALYTICS_EVENT_NAME = process.env.NEXT_PUBLIC_ANALYTICS_EVENT_NAME || "InfluencerAppEvents";
const ANALYTICS_SCHEMA_VERSION = process.env.NEXT_PUBLIC_ANALYTICS_SCHEMA_VERSION || "1.0.0";

const getAnalyticsEnabled = (): boolean => {
    const analyticsEnabled = process.env.NEXT_PUBLIC_ANALYTICS_ENABLED;
    if (!analyticsEnabled) {
        return false;
    }
    return analyticsEnabled.trim().toUpperCase() === "YES";
};

const ClientEventInfo = {
    eventName: ANALYTICS_EVENT_NAME,
    sessionId: nanoid(),
    eventId: 0,
    schemaVersion: ANALYTICS_SCHEMA_VERSION,
};

const getUserAgent = () => {
    if (typeof window === 'undefined') return 'unknown';
    return window.navigator.userAgent;
};

const getAppVersion = () => {
    return process.env.NEXT_PUBLIC_APP_VERSION || '1.0.0';
};

export class SendEventModule {
    currentScreen = "-";
    userID = "";
    sessionId = "";

    setUser = (user: EventNullProps): void => {
        this.userID = user ?? "-";
    };

    setSessionId = (sessionId: EventNullProps): void => {
        this.sessionId = sessionId ?? "-";
    };

    updateScreenNameOnly = (screen: EventNullProps): void => {
        this.currentScreen = screen ?? "-";
    };

    customEvent = (event: SendEvent): void => {
        if (!getAnalyticsEnabled()) {
            return;
        }

        const screen = this.currentScreen;
        const _screen: string = screen ? (RouteToAnalyticsScreenMap[screen] || screen) : "-";

        const dpEventPayload: SendEvent = {
            [EventField.USER_ID]: this.userID,
            [EventField.SN]: _screen,
            [EventField.TS]: Date.now().toString(),
            [EventField.US]: this.sessionId || localStorage.getItem('session-info') || '',
            [EventField.SI]: ClientEventInfo.sessionId,
            [EventField.UA]: getUserAgent(),
            [EventField.AV]: getAppVersion(),
            [EventField.SOURCE]: 'web',
            ...event,
        };

        Analytics.logEvent({
            header: {
                eventId: ClientEventInfo.eventId++,
                uuid: nanoid(),
                appName: APP_NAME,
                timestamp: Date.now(),
                schemaVersion: ClientEventInfo.schemaVersion ?? "",
                name: ClientEventInfo.eventName ?? "",
            },
            event: dpEventPayload,
        });
    };
}

